module.exports = __webpack_public_path__ + "img/sms_icon.078831b3.svg";